module.exports = __webpack_public_path__ + "img/cashBag.b0d14bbf.svg";